import { Link_Group } from '@/src/generated/graphql'
import { Dict } from '@/src/helpers/common.types'
import { convertDirectusLinkToHref } from '@/src/components/common/Link'

export const convertLinkGroupToMenuItems = (_: (Link_Group | null)[]) => {
  return (
    _?.reduce(
      (menuItems, item) => {
        if (!item?.title || !item?.links?.length) return menuItems
        menuItems[item.title] = item.links.reduce((links, link) => {
          if (!link?.text) return links
          links[link.text] = convertDirectusLinkToHref(link) ?? '#'
          return links
        }, {} as Dict<string>)
        return menuItems
      },
      {} as Dict<Dict<string>>,
    ) ?? {}
  )
}
